// extracted by mini-css-extract-plugin
module.exports = {"fade-content":"Home_fade-content__338JI"};